import React, { useContext, useState } from 'react'
import ProductAttributesList from './CollapsibleAttributes/ProductAttributesList'
import { DocumentsList } from './CollapsibleAttributes/DocumentList'
import { Heading } from 'chemistry'
import { TranslateContext } from 'client/common/translator'

const VISIBLE_FILTERS = 12
const VISIBLE_FILTERS_FOR_CLUSTERED_ATTRIBUTES = 3

const Attributes = ({ productDetails, lang, pimAttributesTranslations = {} }) => {
  const t = useContext(TranslateContext)
  const [isExpanded, setIsExpanded] = useState(false)
  const isAttributesClustered = productDetails?.clustered
  const visibleFiltersCount = isAttributesClustered ? VISIBLE_FILTERS_FOR_CLUSTERED_ATTRIBUTES : VISIBLE_FILTERS

  return (
    <div className='mxd-classification-attributes-container'>
      <div data-toggle-active={isExpanded} />
      <Heading size='md'>{t('clustered_attr_list_header')}</Heading>
      <ProductAttributesList
        attributes={productDetails.attributes}
        isAttributesClustered={isAttributesClustered}
        visibleFiltersCount={visibleFiltersCount}
        lang={lang}
        isOpen={isExpanded}
        setIsOpen={() => setIsExpanded(prevState => !prevState)}
        pimAttributesTranslations={pimAttributesTranslations}
      />
      {!!productDetails?.documents?.length && <DocumentsList documents={productDetails.documents} lang={lang} />}
    </div>
  )
}

export default Attributes
